import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Route-aware browser tab title. Admin pages get an "Admin" suffix so
// staff with both an admin tab and a supplier-portal tab open (common
// during testing or when impersonating) can tell them apart at a
// glance. Supplier portal, login, password flows, supplier setup form,
// and supplier help articles keep the plain product title.
//
// Lives next to AlchemyFooter as a small route-aware effect mounted
// inside BrowserRouter at the app root.
const SUPPLIER_OR_AUTH_PREFIXES = ['/portal', '/supplier-form', '/help'];
const SUPPLIER_OR_AUTH_EXACT = new Set(['/', '/forgot-password', '/change-password']);

const ADMIN_TITLE = 'Fusion 2K - Supply Pilot Admin';
const DEFAULT_TITLE = 'Fusion 2K - Supply Pilot';

export default function DocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const isSupplierOrAuth =
      SUPPLIER_OR_AUTH_EXACT.has(pathname) ||
      SUPPLIER_OR_AUTH_PREFIXES.some(p => pathname === p || pathname.startsWith(p + '/'));
    document.title = isSupplierOrAuth ? DEFAULT_TITLE : ADMIN_TITLE;
  }, [pathname]);
  return null;
}
